import UserSelect from "@/components/user-select";
import { routes } from "@/config/routes";
import { useAdvanceFeatures } from "@/hooks/use-advance-features";
import useProfile from "@/hooks/use-profile";
import { Roles } from "@/utilities/types/Users";
import cn from "@/utils/class-names";
import { useState } from "react";
import toast from "react-hot-toast";
import { BsPlusSquare } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { Button, Loader, Modal } from "rizzui";

export const CreateNewCard = ({
  loading = false,
  currentTotalLDP,
}: {
  loading?: boolean;
  currentTotalLDP: number;
}) => {
  const { profile } = useProfile();

  const { landingPageFeature } = useAdvanceFeatures();

  const limitLdpCreation = landingPageFeature?.limitCreation;

  const isAdmin = profile?.role === Roles.ADMIN;

  const navigate = useNavigate();

  const [userId, setUserId] = useState<string | null>(
    isAdmin ? null : profile?.id ?? null
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleNavigate = () => {
    if (
      profile?.role === Roles.AGENCY &&
      limitLdpCreation &&
      currentTotalLDP >= limitLdpCreation
    ) {
      toast.error("Landing page creation limit reached.");
      return;
    }

    if (userId) {
      navigate(routes.landingPages.create, {
        state: {
          userId,
        },
      });
    } else {
      setIsModalOpen(true);
    }
  };
  return (
    <>
      <button
        onClick={() => {
          handleNavigate();
        }}
        className={cn(
          "flex min-h-[200px] border-black justify-center items-center group rounded-lg border border-dashed cursor-pointer overflow-hidden flex-col bg-transparent w-full h-auto",
          loading && "animate-pulse select-none pointer-events-none"
        )}
      >
        {loading ? (
          <Loader className="w-8 h-8 rounded-full" />
        ) : (
          <div className="flex-col gap-2 flex justify-center items-center">
            <BsPlusSquare className="size-8 opacity-75" />
            <p>Create new Landing page</p>
          </div>
        )}
      </button>

      {isAdmin && (
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <div className="p-5 flex flex-col gap-4">
            <p className="text-lg font-medium">
              Please select user to create landing page
            </p>
            <UserSelect
              label="Select User"
              placeholder="Select User"
              value={userId}
              onChange={(userId: string) => {
                setUserId(userId);
              }}
            />

            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={() => setIsModalOpen(false)}>
                Cancel
              </Button>

              <Button
                onClick={() => {
                  handleNavigate();
                }}
                disabled={!userId}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
